// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19NKR","name":"styles_name__2SpR9","phone":"styles_phone__2_1gb"};